import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  to, 
  href, 
  onClick, 
  variant = 'primary', 
  size = 'md',
  className = '',
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium transition-all duration-300 focus:outline-none';
  
  const variantClasses = {
    primary: 'bg-primary text-dark hover:bg-primary/80 border border-primary',
    secondary: 'bg-secondary text-light hover:bg-secondary/80 border border-secondary',
    accent: 'bg-accent text-dark hover:bg-accent/80 border border-accent',
    outline: 'bg-transparent border border-primary text-primary hover:bg-primary/10',
    dark: 'bg-dark text-light hover:bg-dark/80 border border-gray-800',
    light: 'bg-light text-dark hover:bg-light/80 border border-light',
    minimal: 'bg-transparent text-primary hover:text-primary/80 underline',
  };
  
  const sizeClasses = {
    sm: 'text-sm px-3 py-1.5',
    md: 'text-base px-4 py-2',
    lg: 'text-lg px-6 py-3',
  };
  
  const allClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;
  
  if (to) {
    return (
      <Link to={to} className={allClasses} {...props}>
        {children}
      </Link>
    );
  }
  
  if (href) {
    return (
      <a href={href} className={allClasses} {...props}>
        {children}
      </a>
    );
  }
  
  return (
    <button className={allClasses} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default Button;
